import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../services/api';

export default function Register() {
  const [formData, setFormData] = useState({
    dealership_name: '',
    primary_contact_name: '',
    primary_contact_email: '',
    primary_contact_phone: '',
    password: '',
    street_address: '',
    city: '',
    state: '',
    zip_code: '',
    phone: '',
  });
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
  };

  const validate = () => {
    const errors = {};
    if (formData.password.length < 12) errors.password = 'Password must be at least 12 characters';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.primary_contact_email)) errors.primary_contact_email = 'Invalid email format';
    if (!/^\d{5}(-\d{4})?$/.test(formData.zip_code)) errors.zip_code = 'Invalid ZIP code';
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validate()) return;
    setLoading(true);

    try {
      await api.register(formData);
      alert('Registration successful! Please login.');
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box" style={{ maxWidth: '600px' }}>
        <h2>Dealer Registration</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Dealership Name *</label>
            <input name="dealership_name" value={formData.dealership_name} onChange={handleChange} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Contact Name *</label>
              <input name="primary_contact_name" value={formData.primary_contact_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Contact Email *</label>
              <input type="email" name="primary_contact_email" value={formData.primary_contact_email} onChange={handleChange} required />
              {fieldErrors.primary_contact_email && <span className="field-error">{fieldErrors.primary_contact_email}</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Contact Phone *</label>
              <input name="primary_contact_phone" value={formData.primary_contact_phone} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Password * (min 12 characters)</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} required minLength={12} />
              {fieldErrors.password && <span className="field-error">{fieldErrors.password}</span>}
            </div>
          </div>
          <div className="form-group">
            <label>Street Address *</label>
            <input name="street_address" value={formData.street_address} onChange={handleChange} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>City *</label>
              <input name="city" value={formData.city} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>State *</label>
              <input name="state" value={formData.state} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>ZIP Code *</label>
              <input name="zip_code" value={formData.zip_code} onChange={handleChange} required />
              {fieldErrors.zip_code && <span className="field-error">{fieldErrors.zip_code}</span>}
            </div>
            <div className="form-group">
              <label>Dealership Phone *</label>
              <input name="phone" value={formData.phone} onChange={handleChange} required />
            </div>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
        <div className="link">
          <Link to="/login">Already have an account? Login</Link>
        </div>
      </div>
    </div>
  );
}
